import http, { url } from '../../http'

const API_URL = "structure_meters"

class indicadoresAPI {

  async save(resource) {
    const response = await http(`${API_URL}/save`, 'POST', resource)
    return response
  }

  async saveF(resource) {
    const response = await http(`measurement_medical_config_data_sheet/save`, 'POST', resource)
    return response
  }

/*   async getAll(page) {
    const response = await http(`${API_URL}?page=${page}`)
    return response
  } 
 */

  async getAllF(id, page, search) {
    const response = await http(`measurement_medical_config_data_sheet/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } 


  async getF(id) {
    const response = await http(`measurement_medical_config_data_sheet/index/${id}`, 'POST')
    return response
  }

  async getListE() {
    const response = await http(`${API_URL}/structureIndicators/list`)
    return response
  }

  async getListP() {
    const response = await http(`${API_URL}/processIndicators/list`)
    return response
  }

  async getListR() {
    const response = await http(`${API_URL}/resultIndicators/list`)
    return response
  }

  async getAll(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } 


  async get(id) {
    const response = await http(`${API_URL}/index/${id}`, 'POST')
    return response
  }
  async getCode(resource) {
    const response = await http(`measurement_medical_reports/diagnostic_codes`, 'POST', resource)
    return response
  }
/* 
  async getExcel(id) {
    const response = url(`${API_URL}/excelAdvance/${id}`)
    return response
  }  */

  async getExcel(companyId, resource) {
    let user = JSON.parse(localStorage.getItem("user"));

    if (user.token) {
      return url(
        `${API_URL}/exportExcel/${companyId}?&access_token=${user.token}`, 'POST', resource
      );
    }

  }


  async getShow(id) {
    const response = await http(`${API_URL}/show/${id}`)
    return response
  }

  async saveY(id, resource) {
    const response = await http(`${API_URL}/absenteeismMonthly/${id}`, 'POST',resource)
    return response
  }

  async saveMonth(id, resource) {
    const response = await http(`${API_URL}/report/${id}`, 'POST', resource)
    return response
  }

  async month( resource) {
    const response = await http(`${API_URL}/busyDays`, 'POST', resource)
    return response
  }

  async saveYears(id, resource) {
    const response = await http(`${API_URL}/reportAnual/${id}`, 'POST', resource)
    return response
  }

  async update(id, resource) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', resource)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  } 
  
}

export default new indicadoresAPI()